// extracted by mini-css-extract-plugin
export var quantityInput = "_gz-0";